import * as React from 'react';
import { Card, CardContent, Divider } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';
import { Filter } from 'services/clients/perDiem';

interface Props {
  filter: Filter;
  clearSearch: () => void;
  className?: string;
}

export const ReportCard: React.FC<Props> = (props) => {
  const { filter, clearSearch, className } = props;
  const [showHover, setShowHover] = React.useState(false);

  const filterItems = [
    {
      title: 'Shipping line',
      value: filter.shippingLine,
    },
    {
      title: 'Container type',
      value: filter.containerType,
    },
    {
      title: 'Date range',
      value: `${filter.startDate} - ${filter.endDate}`,
    },
  ];

  return (
    <Card
      className={`shadow-md flex items-center ${className}`}
      style={{ borderRadius: 16 }}
      onMouseEnter={() => setShowHover(true)}
      onMouseLeave={() => setShowHover(false)}
    >
      {showHover ? (
        <CardContent
          className="flex items-center justify-center bg-blue-100 w-full h-full cursor-pointer"
          onClick={() => {
            setShowHover(false);
            clearSearch();
          }}
        >
          <div className="text-center">
            <ReplayIcon className="text-blue-900" width={16} />
            <h3 className="text-lg text-blue-900 font-medium">Start a new report</h3>
          </div>
        </CardContent>
      ) : (
        <CardContent className="flex p-4 lg:p-1 gap-6 items-center justify-evenly w-full h-full">
          <div className="hidden text-center lg:block">
            <ReplayIcon className="text-blue-900" width={16} />
            <h3 className="text-lg text-blue-900 font-medium">Start a new report</h3>
          </div>

          <Divider orientation="vertical" flexItem className="hidden bg-blue-300 my-3 lg:block" />

          <div className="flex flex-col gap-2 w-full lg:w-1/2">
            <div className="w-full">
              <div className="flex flex-col gap-3">
                {filterItems.map((item) => (
                  <div className="flex justify-between" key={item.value}>
                    <span className="hidden font-medium md:block">{item.title}:</span>
                    <span>{item.value}</span>
                  </div>
                ))}
              </div>
            </div>
            <Divider className="lg:hidden bg-blue-300" />
            <div className="lg:hidden flex text-left md:justify-center items-center gap-2 block">
              <ReplayIcon className="text-blue-900" style={{ width: 16 }} />
              <h3 className="text-xs text-blue-900 font-medium">Start a new report</h3>
            </div>
          </div>
        </CardContent>
      )}
    </Card>
  );
};
ReportCard.displayName = 'PerDiemArchive.SmartPerDiem.ReportCard';
